import React from 'react';
import PropTypes from 'prop-types';
import {
  MaterialIcon,
  Button,
} from '@pearsontechnology/aero-components';

export const GreyButton = ({ iconName, ...rest }) => (
  <Button grey iconOnly height={34} {...rest}>
    <MaterialIcon id={iconName} />
  </Button>
);

GreyButton.propTypes = {
  iconName: PropTypes.string.isRequired,
};

const MoreButton = (props) => <GreyButton name="more_vert" iconName="more_vert" {...props} />;
export default MoreButton;
